import $ from 'jquery';
import gaJsonData from './ga.json';

window.dataLayer = window.dataLayer || [];

const initGaTracking = () => {
    let _cfg = {
        data: gaJsonData
    };

    const _handleClicked = (dom, gaData) => {
        dom.on('click', function () {
          console.warn('_handleClicked - Dom Clicked, gaData: ', gaData);
          // console.warn('send, ', ' event, ', gaData.category, ', ', gaData.action, ', ', gaData.label.substring(0, 100));
          window.dataLayer.push(gaData);
        });
    };
    const _handleAction = (dom, gaData) => {
        switch (gaData.event_action_DL) {
        case 'clicked':
          _handleClicked(dom, gaData);
          break;
        default:
          // console.log('out of action options');
        }
    };

    const _initTracking = () => {
        $('.gabtn').each(function () {
           const dom = $(this);
           const gaid = dom.data('gaid');
           const gaData = _cfg.data[gaid];
           // console.log('gaData: ', gaData);
           // console.log('dom class: ', dom.attr('class'));
           if (!gaData) { return; }
           // console.log('dom gaData: ', gaData);
           _handleAction(dom, gaData);
        });
    };
    _initTracking();
}

export default initGaTracking;